export class ValidateResourceConfigurationResponse {
    'isValid';
    'errors';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "isValid",
            "baseName": "isValid",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "errors",
            "baseName": "errors",
            "type": "Array<ResourceValidationError>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ValidateResourceConfigurationResponse.attributeTypeMap;
    }
    constructor() {
    }
}
